import React from 'react';
import { Leaf } from 'lucide-react';

interface CTASectionProps {
  headline: string;
  subheadline?: string;
  ctaText: string;
  ctaAction: () => void;
  backgroundColor?: string;
}

export default function CTASection({
  headline,
  subheadline,
  ctaText,
  ctaAction,
  backgroundColor = 'bg-gradient-to-br from-primary-500 to-primary-600'
}: CTASectionProps) {
  return (
    <section className={`py-16 ${backgroundColor}`}>
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          {headline}
        </h2>
        {subheadline && (
          <p className="text-xl text-white/90 mb-8">
            {subheadline}
          </p>
        )}
        <button
          onClick={ctaAction}
          className="bg-white text-primary-600 py-4 px-8 rounded-lg hover:bg-gray-100 transition-all duration-300 font-bold text-lg shadow-xl hover:shadow-2xl hover:-translate-y-0.5 inline-flex items-center gap-2"
        >
          <Leaf className="h-6 w-6" />
          {ctaText}
        </button>
      </div>
    </section>
  );
}
